"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var QueryControl_styles_1 = require("./QueryControl.styles");
var TimeControl_1 = __importDefault(require("../TimeControl/TimeControl"));
var AggregationControl_1 = __importDefault(require("../AggregationControl/AggregationControl"));
var ConditionsControl_1 = __importStar(require("../ConditionsControl/ConditionsControl"));
var Button_1 = __importDefault(require("../Button/Button"));
var QueryControl = function (_a) {
    var value = _a.value, onChange = _a.onChange, className = _a.className;
    var styles = (0, QueryControl_styles_1.useStyles)();
    var handleTimeChange = function (time) {
        onChange(__assign(__assign({}, value), { time: time }));
    };
    var handleAggregationChange = function (aggregation) {
        onChange(__assign(__assign({}, value), { aggregation: aggregation }));
    };
    var handleWhereChange = function (conditions) {
        onChange(__assign(__assign({}, value), { conditions: conditions }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(styles.component, " ").concat(className) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.time }, { children: [(0, jsx_runtime_1.jsx)(AggregationControl_1.default, { value: value.aggregation, onChange: handleAggregationChange }), (0, jsx_runtime_1.jsx)(TimeControl_1.default, { value: value.time, aggregation: value.aggregation, onChange: handleTimeChange })] })), value.conditions ?
                (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ConditionsControl_1.default, { conditions: value.conditions, onChange: handleWhereChange }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ className: styles.deleteFilter, variant: "text", onClick: function () {
                                if (window.confirm("Filter wirklich löschen?")) {
                                    handleWhereChange(undefined);
                                }
                            } }, { children: "Filter l\u00F6schen" }))] })
                : null, !value.conditions ?
                (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outline", onClick: function () {
                        handleWhereChange(ConditionsControl_1.defaultValue);
                    } }, { children: "Filter" }))
                : null] })));
};
exports.default = QueryControl;
